<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select">
            <!-- <div class="topic_type">多选题</div> -->
            <div class="topic_content scroll_x flex-1 mar_left_10">
                <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
                <div>
                    <el-checkbox-group v-model="topicInfo.doAnswer" @change="changeAnswer">
                        <el-checkbox v-for="(item, index) in topicInfo?.options" :key="index"
                            :value="item.serial.toString()" size="large" :disabled="disabled">
                            <div class="flex FlexBaseline">
                                <div>{{ item.label }} .</div>
                                <div class="editor_box" v-html="$Tools.handlerImg(item.content)" v-mathml></div>
                            </div>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    props: {
        questionInfo: {},
        disabled:{}
    },
    computed: {
        ...mapState({
            // testExamTime: (state) => state.exam.testExamTime,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = JSON.parse(val);
                    // 多选题答案为数组,将正确答案也变为数组
                    if (this.$Tools.empty(this.topicInfo.doAnswer)) {
                        this.topicInfo.doAnswer = [];
                        // 判断是不是数组，不是数组转换
                        if(!Array.isArray(this.topicInfo?.answer)){
                            this.topicInfo.answer = this.topicInfo?.answer?.split(',');
                        }
                        // 判断是否回答过
                        if(this.topicInfo.courseExamRecordId){
                            console.log(this.topicInfo.doAnswer.split(","))
                            this.topicInfo.doAnswer = this.topicInfo.doAnswer.split(",");
                        }
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() { },

    methods: {
        changeAnswer(value) {
            // console.log(this.topicInfo.doAnswer);
            // console.log(this.topicInfo.questionContext?.answer);
            // console.log(this.areArraysEqual(value, this.topicInfo.questionContext?.answer))
            if(this.areArraysEqual(value, this.topicInfo?.answer)){
                this.topicInfo.isCorrect = 1;
            }else{
                this.topicInfo.isCorrect = 2;
            }
            this.topicInfo.questionScore = (this.topicInfo.isCorrect == 1?this.topicInfo.score:0); // 得分
            // this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer.join(",");   // 保存答案
            // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
            this.$emit('answerQuestion',this.topicInfo);
        },
        // 判断数组是否相同（内容）
        areArraysEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;

            // 类型归一化函数（仅转换字符串数字）
            const normalize = (item) => {
                if (typeof item === 'string') {
                    const num = Number(item);
                    return isNaN(num) ? item : num; // 非数字字符串保留原样
                }
                return item;
            };

            // 归一化后排序
            const sortedArr1 = [...arr1].map(normalize).sort((a, b) => a - b);
            const sortedArr2 = [...arr2].map(normalize).sort((a, b) => a - b);

            // 严格比较（支持 NaN）
            return sortedArr1.every((elem, index) =>
                Object.is(elem, sortedArr2[index])
            );
        }
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        // overflow-x: auto;
        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
        .editor_box{
            white-space: normal;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
:deep(.el-checkbox.el-checkbox--large) {
    display: flex;
    align-items: baseline;
    min-height: 36px;
    height: auto;
}
:deep(.el-checkbox__label) {
    line-height: normal;
}
</style>